import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
  name: 'formatCnpj',
})
export class FormatCnpjPipe implements PipeTransform {
  transform(v: string): string {
    let pad = new Array(15).join("0");
    v = (pad + String(v)).slice(-14);
    v = v.replace(/\D/g, ''); //Remove tudo o que não é dígito
    v = v.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
    return v;
  }
}
